import { useState } from "react"
import { router } from "@inertiajs/react"
import { StepShell } from "../components/StepShell"
import { DynamicList } from "../components/DynamicList"
import { VoiceField } from "@/components/planning/client-only/VoiceField"
import { GuideMeCta } from "@/components/planning/client-only/GuideMeCta"

function defaultRows(saved) {
  if (saved && saved.length > 0) return saved
  return Array.from({ length: 3 }, () => ({ text: "" }))
}

export function PersonalGoals({ data }) {
  const [goals, setGoals] = useState(() => defaultRows(data.annualPlan.personalGoals))
  const [processing, setProcessing] = useState(false)

  const hasEnough = goals.filter((g) => g.text?.trim().length > 0).length >= 1

  const submit = () => {
    setProcessing(true)
    router.patch(
      "/app/plan/intake",
      { step: "personal_goals", personal_goals: goals, advance: "1" },
      {
        preserveScroll: true,
        onFinish: () => setProcessing(false),
      },
    )
  }

  const insertGuidedBullets = (bullets) => {
    setGoals(() => {
      const rows = bullets.slice(0, 5).map((text) => ({ text }))
      while (rows.length < 1) rows.push({ text: "" })
      return rows
    })
  }

  return (
    <StepShell
      title="Your top 3–5 goals"
      subtitle="Spiritual, personal, and vocational — the things you're really aiming at this year."
      onNext={submit}
      nextDisabled={!hasEnough}
      processing={processing}
    >
      <GuideMeCta
        section="personal_goals"
        onInsert={insertGuidedBullets}
        title="Not sure where to start?"
        subtitle="Talk it through with an AI coach — answer a few questions and it'll help you shape your top goals."
      />
      <DynamicList
        items={goals}
        onChange={setGoals}
        min={1}
        max={5}
        newItem={() => ({ text: "" })}
        addLabel="Add another goal"
        render={(item, update) => (
          <VoiceField
            value={item.text}
            onChange={(v) => update("text", v)}
            placeholder="e.g., Build a weekly Sabbath rhythm with my family"
            rows={2}
            ariaLabel="Top goal"
          />
        )}
      />
    </StepShell>
  )
}
